import { use } from 'react'
import { LogsExplorerContext } from '@/components/shared/logs-explorer/context/context'

export const useLogsExplorer = () => {
  const context = use(LogsExplorerContext)
  if (!context) {
    throw new Error(
      'useLogsExplorer must be used within a LogsExplorerProvider'
    )
  }
  return context
}
